import { IPatientDetail, ITwilioAccessToken } from "@curefit/care-common";
import { Client } from "@twilio/conversations";
import { ApiManager } from "../api/ApiManager";
import CommunicationAccessTokenRequestParamsBuilder from "../builder/CommunicationAccessTokenRequestParamsBuilder";
import { AccessTokenRequestConstants } from "../utils/AppConstants";
import { PatientCompleteInfoActions } from "../actions/PatientCompleteInfoActions";
import {
  CHANNEL_SYNCHRONIZATION_COMPLETE,
  CLEAR_CURRENT_CHANNEL,
  CLOSE_WHATSAPP_CHAT,
  FETCH_UNREAD_MESSAGE_INFO,
  SET_TWILIO_CLIENTS,
  SET_TWILIO_CURRENT_CHANNEL,
  UPDATE_CONNECTION_STRENGTH,
  UPDATE_PATIENT_WHATSAPP_INFO,
  UPDATE_TWILIO_ACCESS_TOKEN,
  UPDATE_TWILIO_CHANNEL_INFO,
  UPDATE_TWILIO_CURRENT_CHANNEL,
  UPDATE_TWILIO_CURRENT_CHANNEL_WITH_PATIENT,
  UPDATE_TWILIO_TOTAL_UNREAD_COUNT,
} from "./ActionTypes";
import IUnreadMsgInfo from "../models/twilio/IUnreadMsgInfo";
import AppUtils from "../utils/AppUtils";
import { Tracker } from "../utils/Tracker";
import { EventNames } from "../utils/EventTrackerConstants";
import {
  CONVERSE_SDK_EVENTS,
  eventDispatcher,
} from "@curefit/converse-chat-sdk";
import { WhatsAppPatientInfo } from "../components/WhatsAppChatComponent";

declare let Twilio: any;

export class TwilioActions {
  static fetchChatContextAndInitTwilioClients(dispatch: any, id: number) {
    let reqBuilder: CommunicationAccessTokenRequestParamsBuilder =
      new CommunicationAccessTokenRequestParamsBuilder();
    reqBuilder.setCommUserId(id);
    reqBuilder
      .setCommMode(AccessTokenRequestConstants.commMode.CHAT)
      .setEndPointId(AccessTokenRequestConstants.endPointId.WEB)
      .setCommUserType(AccessTokenRequestConstants.commUserType.DOCTOR);
    ApiManager.getAlbusApis()
      .getTwilioContext(reqBuilder.build())
      .then(async (accessToken) => {
        TwilioActions.initiateTwilioClients(dispatch, accessToken);
        dispatch(TwilioActions.fetchChatAccessTokenSuccess(accessToken));
      })
      .catch((error) => {
        throw error;
      });
  }

  static async initiateTwilioClients(
    dispatch: any,
    accessToken: ITwilioAccessToken[]
  ) {
    let clientsMap: { [key: string]: any } = {};
    console.time("twilioClients");
    const start = performance.now();
    let clientsRes = accessToken.map((accessToken: ITwilioAccessToken) => {
      return new Client(accessToken.tokenString);
    });
    try {
      accessToken.map((accessToken: ITwilioAccessToken, index: number) => {
        clientsMap[accessToken.identity] = clientsRes[index];
      });
    } catch (e) {
      console.log("TWILIO CLIENTS ERR: ", e);
    }
    console.timeEnd("twilioClients");
    const end = performance.now();
    const loadingTime = end - start;
    Tracker.track(EventNames.Twilio_Client_Load, { loadingTime });
    dispatch({ type: SET_TWILIO_CLIENTS, clientsMap }); // {}
  }

  static fetchChatContext(dispatch: any, id: number) {
    let reqBuilder: CommunicationAccessTokenRequestParamsBuilder =
      new CommunicationAccessTokenRequestParamsBuilder();
    reqBuilder.setCommUserId(id);
    reqBuilder
      .setCommMode(AccessTokenRequestConstants.commMode.CHAT)
      .setEndPointId(AccessTokenRequestConstants.endPointId.WEB)
      .setCommUserType(AccessTokenRequestConstants.commUserType.DOCTOR);
    ApiManager.getAlbusApis()
      .getTwilioContext(reqBuilder.build())
      .then((accessToken) => {
        dispatch(TwilioActions.fetchChatAccessTokenSuccess(accessToken));
      })
      .catch((error) => {
        throw error;
      });
  }

  static fetchChatAccessTokenSuccess(accessToken: ITwilioAccessToken[]) {
    return { type: UPDATE_TWILIO_ACCESS_TOKEN, accessToken };
  }

  static updateChannelInfo(channelInfo: any[]) {
    return { type: UPDATE_TWILIO_CHANNEL_INFO, channelInfo };
  }

  static updateTotalUnreadCount(unreadCount: number) {
    return { type: UPDATE_TWILIO_TOTAL_UNREAD_COUNT, unreadCount };
  }

  static updateCurrentChannel(channelSid: string) {
    return { type: UPDATE_TWILIO_CURRENT_CHANNEL, channelSid };
  }

  static updateCurrentChannelWithPatient(
    channelSid: string,
    patient: IPatientDetail,
    identity: string
  ) {
    return {
      type: UPDATE_TWILIO_CURRENT_CHANNEL_WITH_PATIENT,
      channelSid,
      patient,
      identity,
    };
  }

  static setCurrentChannel(channel: any) {
    console.timeEnd("setChannel");
    return { type: SET_TWILIO_CURRENT_CHANNEL, channel };
  }

  static channelsSyncComplete() {
    return { type: CHANNEL_SYNCHRONIZATION_COMPLETE, payload: true };
  }

  static updateUnreadMessageInfo(dispatch: any,newMessage :any,prevMessage :any) {
    let isChannelPresent = prevMessage.findIndex((data: any) => {
      return (
        data.twilioUnreadMessageCountView.channelSid ===
        newMessage.twilioUnreadMessageCountView.channelSid
      );
    });
    if (isChannelPresent === -1) {
      const query: any = {
        pageNo: 0,
        pageSize: 1000,
        sortOrder: "CONSULTATION",
        patientNameContains: "",
      };
      TwilioActions.searchPatients(newMessage.patient.name).then(
        (result) => {
          console.log(result);
          let patient = result[0]
          newMessage.patient = patient;
          prevMessage.unshift(newMessage);
          dispatch(TwilioActions.fetchUnreadMessageInfoSuccess(prevMessage));
        }
      );
    } else {
      if (
        newMessage.twilioUnreadMessageCountView.lastMessageTimestamp ===
        prevMessage[isChannelPresent].twilioUnreadMessageCountView
          .lastMessageTimestamp
      ) {
        dispatch(TwilioActions.fetchUnreadMessageInfoSuccess(prevMessage));
      } else {
        let temp = prevMessage[isChannelPresent];
        newMessage.twilioUnreadMessageCountView.unreadMessageCount =
          temp.twilioUnreadMessageCountView.unreadMessageCount + 1;
        temp.twilioUnreadMessageCountView =
          newMessage.twilioUnreadMessageCountView;
        //temp.twilioUnreadMessageCountView.l = newMessage.twilioUnread
        prevMessage.splice(isChannelPresent, 1);
        prevMessage.unshift(temp);
        dispatch(TwilioActions.fetchUnreadMessageInfoSuccess(prevMessage));
      }
    }
  }
  

  static getUnreadMessageInfo(
    dispatch: any,
    doctorId: string,
  ) {
    ApiManager.getAlbusApis()
      .fetchUnreadMessageInfo(doctorId)
      .then((unreadMsgs) => {
          dispatch(TwilioActions.fetchUnreadMessageInfoSuccess(unreadMsgs));
        })
      .catch((error) => {
        throw error;
      });
  }

  static fetchUnreadMessageInfoSuccess(unreadMsgInfo: IUnreadMsgInfo[]) {
    return { type: FETCH_UNREAD_MESSAGE_INFO, payload: unreadMsgInfo };
  }

  static searchPatients(curefitUserId: string) {
    return PatientCompleteInfoActions.searchPatients(curefitUserId);
  }

  static fetchDoctorPatients(doctorId: number, query: any) {
    return PatientCompleteInfoActions.searchDoctorPatients(doctorId, query);
  }

  static updateConsumptionHorizon(dispatch :any,channelSid: string, previousMessage: any) {
    if (previousMessage.length === 0 ) return
    let channelIndex = previousMessage.findIndex((data:any) => data.twilioUnreadMessageCountView.channelSid ===
    channelSid)

    if(channelIndex === -1) return

    let temp = [...previousMessage]
    temp[channelIndex].twilioUnreadMessageCountView.unreadMessageCount = 0
    dispatch(TwilioActions.fetchUnreadMessageInfoSuccess(temp));
  }

  static clearCurrentChannel() {
    return { type: CLEAR_CURRENT_CHANNEL };
  }

  static setConnectionStrengthMessage(connectionStrengthMessage: string) {
    return {
      type: UPDATE_CONNECTION_STRENGTH,
      payload: connectionStrengthMessage,
    };
  }

  static updateConnectionStrength(
    dispatch: any,
    connectionStrengthMessage: string
  ) {
    dispatch(
      TwilioActions.setConnectionStrengthMessage(connectionStrengthMessage)
    );
  }
}
